(function() {
  function filterImages(variantTitle) {
    var title = variantTitle.toLowerCase().trim();
    var allMedia = document.querySelectorAll('.product__media-item');
    
    if (allMedia.length === 0) {
      allMedia = document.querySelectorAll('[data-media-id]');
    }

    var hasMatches = false;
    allMedia.forEach(function(item) {
      var img = item.querySelector('img');
      var alt = img ? img.alt.toLowerCase().trim() : '';
      if (alt.includes(title)) hasMatches = true;
    });

    allMedia.forEach(function(item) {
      var img = item.querySelector('img');
      var alt = img ? img.alt.toLowerCase().trim() : '';
      
      if (!hasMatches || alt === '' || alt.includes(title)) {
        item.style.display = '';
        item.style.opacity = '1';
      } else {
        item.style.display = 'none';
      }
    });
  }

  // Escucha múltiples eventos posibles del tema Warehouse
  var events = ['variant:change', 'variantChange', 'on:variant:change'];
  events.forEach(function(eventName) {
    document.addEventListener(eventName, function(e) {
      var variant = e.detail && (e.detail.variant || e.detail);
      if (variant && variant.title) {
        filterImages(variant.title);
      }
    });
  });

  // También detecta cambios en los selectores de variante directamente
  document.addEventListener('change', function(e) {
    var target = e.target;
    if (target && (target.name === 'Color' || target.dataset.option)) {
      filterImages(target.value);
    }
  });

  // Para swatches que usan clicks
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('[data-value], .swatch__item, .variant-input');
    if (swatch) {
      var value = swatch.dataset.value || swatch.textContent.trim();
      if (value) filterImages(value);
    }
  });
})();